import { createFileRoute, redirect } from '@tanstack/react-router'

// Proveedores se separó como módulo independiente en /suppliers.
// Esta ruta garantiza que cualquier link existente a /clients/suppliers no rompa.
export const Route = createFileRoute('/_app/clients/suppliers')({
  beforeLoad: () => {
    throw redirect({ to: '/suppliers', replace: true })
  },
  component: () => null,
})
